<template>
  <div class="title-comp1">
    <span class="left">{{ isString(title) ? title : title[0] }}</span>
    <span class="vertical-line"></span>
    <span class="right" v-if="!isString(title)">{{ title[1] }}</span>
  </div>
</template>

<script>
import { isString } from '@/utils/is';

export default {
  name: 'TitleComp1',
  props: {
    title: {
      type: [String, Array],
      default: () => []
    }
  },
  methods: {
    isString
  }
};
</script>

<style lang="scss" scoped>
.title-comp1 {
  min-width: 200px;
  height: 40px;
  color: $normal-color;
  font-size: 18px;
  background: url('~@/assets/image/title-bg.png') no-repeat left center;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .left {
    text-indent: 15px;
  }

  .right {
    text-indent: 7px;
  }

  .vertical-line {
    display: inline-block;
    height: 17px;
    width: 2px;
    background-color: $normal-color;
    margin-left: 8px;
  }
}
</style>
